import styled from 'styled-components';

import { ColorNames, colors } from 'utils/styles/theme';

interface BadgeProps {
  backgroundColor?: ColorNames;
  hoverBackground?: ColorNames | string;
  hoverTextColor?: ColorNames | string;
}

const Badge = styled.span<BadgeProps>`
  display: inline-flex;
  white-space: nowrap;

  padding: 10px 20px;
  border-radius: 33px;

  background: ${({ backgroundColor }) =>
    backgroundColor ? colors[backgroundColor] : colors.codGray};

  &:is(a, button) {
    :hover {
      background: ${({ hoverBackground }) =>
        hoverBackground
          ? colors[hoverBackground] ?? hoverBackground
          : colors.codGrayHover};

      ${({ hoverTextColor }) =>
        hoverTextColor &&
        `
          color: ${colors[hoverTextColor] ?? hoverTextColor} !important;
          span {
            color: ${colors[hoverTextColor] ?? hoverTextColor} !important;
          }
        `}
    }
    transition: background-color 0.3s ease;
  }
`;

export default Badge;
